<script>
import { mapActions, mapGetters } from "vuex";

import genders from "../../service/genders";
import UploadFile from "../UploadFile.vue";
const onlyTextRegexp = /[(a-z)(A-Z)(')(`)( )]/;

export default {
  components: { UploadFile },
  props: {
    isReadonly: {
      type: Boolean,
      default: () => false,
    },
  },

  data: () => ({
    isLoading: false,

    isValid: false,

    genders,

    years: Array.from(
      { length: new Date().getFullYear() - 1980 },
      (value, index) => 1981 + index
    ).reverse(),

    onlyText(v) {
      return [...v].filter((x) => x?.match(onlyTextRegexp));
    },
  }),

  computed: {
    ...mapGetters("application", [
      "GET_APPLICATION",
      "GET_DISABILITYS",
      "GET_COUNTRYS",
      "GET_REGIONS",
      "GET_CITYS",
      "GET_SCHOOL_REGIONS",
      "GET_SCHOOL_CITYS",
      "GET_EDUCATION_FACULTYS",
      "GET_EDUCATION_TYPES",
      "GET_EDUCATION_LANGUAGES",
      "GET_SCHOOL_TYPES",
      "GET_CERTIFICATES",
      "GET_ADDITIONAL_FACULTIES",
    ]),
    application: (vm) => vm.GET_APPLICATION,

    isReadonlyForm2() {
      if (this.application.canEditAccepted) {
        return false;
      } else {
        return this.isReadonly;
      }
    },

    isCert: (vm) => vm.application.foreignLanguageProficiency.id != 1,
    isPerevod: (vm) => vm.application.foreignLanguageProficiency.id == 7,
    is2mutaxasis: (vm) => vm.application.foreignLanguageProficiency.id == 8,
    isOtherCert: (vm) => vm.application.foreignLanguageProficiency.id == 6,
  },

  methods: {
    onNext() {
      this.isValid = true;
      if (this.$refs.form.validate()) {
        this.$nextTick(() => {
          const el = document.querySelector(".error--text");

          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          } else {
            this.$emit("next");
          }
        });
      } else {
        this.$store.dispatch("SET_SNACKBAR", {
          text: this.$t("fill_required"),
          color: "info",
        });
      }
    },

    ...mapActions("application", [
      "SET_APPLICATION",
      "SAVE_APPLICATION",
      "INIT_REGIONS",
      "INIT_CITYS",
      "INIT_SCHOOL_CITYS",
      "INIT_EDUCATION_TYPES",
      "INIT_EDUCATION_LANGUAGES",
      "INIT_ADDITIONAL_FACULTIES",
    ]),

    onChangeApp() {
      this.$nextTick(() => {
        this.SET_APPLICATION(this.application);
      });
    },

    onChangeCert() {
      this.application.certificateOther = null;
      this.onChangeApp();
    },

    onChangeCountry() {
      const params = { countryId: this.application.country.id };
      this.isLoading = true;

      this.INIT_REGIONS(params).then(() => {
        this.isLoading = false;
      });

      this.application.region.id = null;
      this.application.city.id = null;

      this.onChangeApp();
    },

    onChangeRegion() {
      const params = { regionId: this.application.region.id };
      this.isLoading = true;

      this.INIT_CITYS(params).then(() => {
        this.isLoading = false;
      });

      this.application.city.id = null;

      this.onChangeApp();
    },

    onChangeSchoolRegion() {
      const params = { regionId: this.application.schoolRegion.id };
      this.isLoading = true;

      this.INIT_SCHOOL_CITYS(params).then(() => {
        this.isLoading = false;
      });

      this.application.schoolCity.id = null;

      this.onChangeApp();
    },

    onChangeEducationFaculty() {
      const params = { id: this.application.educationFaculty.id };
      this.isLoading = true;

      this.application.educationType.id = null;
      this.application.educationLanguage.id = null;
      this.application.additionalFaculty = [];

      this.INIT_EDUCATION_TYPES(params).then(() => {
        this.isLoading = false;
      });

      this.onChangeApp();
    },

    onChangeEducationType() {
      const params = {
        typeId: this.application.educationType.id,
        facultyId: this.application.educationFaculty.id,
      };

      this.isLoading = true;

      this.application.educationLanguage.id = null;
      this.application.additionalFaculty = [];

      this.INIT_EDUCATION_LANGUAGES(params).then(() => {
        this.isLoading = false;
      });

      this.onChangeApp();
    },

    onChangeEducationLanguage() {
      const id = this.application.educationLanguage.id;
      const langs = this.GET_EDUCATION_LANGUAGES;
      const lang = langs.find((x) => x.language.id == id);

      this.application.additionalFaculty = [];

      if (lang) {
        this.application.scienceComplex = lang.scienceComplex || {};

        const params = {
          scienceComplexId: this.application.scienceComplex.id,
          facultyId: this.application.educationFaculty.id,
          typeId1: this.application.educationType.id,
        };

        this.isLoading = true;

        this.INIT_ADDITIONAL_FACULTIES(params).then(() => {
          this.isLoading = false;
        });

        this.onChangeApp();
      }
    },

    onSend() {
      this.isValid = true;
      this.$refs.form.validate();
      this.$refs.form1?.validate();
      this.$refs.form2?.validate();
      this.$nextTick(() => {
        const el = document.querySelector(".error--text");

        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        } else {
          this.SAVE_APPLICATION(this.application);
        }
      });
    },
  },
};
</script>

<template>
  <v-card color="white" elevation="0" rounded="0">
    <v-card-title class="white--text card-header">
      <div class="pl-6"></div>
      <v-btn @click="$emit('prev')" icon dark class="mr-2" large>
        <v-icon> mdi-arrow-left </v-icon>
      </v-btn>
      <div class="fs-26">
        {{ $t("perevod title") }}
      </div>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-form
        :disabled="isLoading || isReadonly"
        ref="form"
        lazy-validation
        onSubmit="return false;"
      >
        <div class="pa-3 pa-md-10">
          <v-row>
            <v-col cols="12" md="6">
              <!-- perevod uchun-->
              <template>
                <div class="accent--text bold--text">
                  {{ $t("OTM nomi") }}
                  <span v-text="'*'" />
                </div>
                <v-text-field
                  autocomplete="off"
                  @blur="onChangeApp"
                  v-model="application.nameOTM"
                  class="text-field"
                  solo
                  :required="true"
                  :rules="[$rules.required]"
                />
                <div class="position-relative">
                  <div
                    v-if="application.reviews.nameOTM && !isReadonly"
                    v-text="application.reviews.nameOTM"
                    class="red--text review-msg"
                  />
                </div>

                <div class="accent--text bold--text">
                  {{ $t("O`qigan ta`lim yo`nalishi") }}
                  <span v-text="'*'" />
                </div>
                <v-text-field
                  autocomplete="off"
                  @blur="onChangeApp"
                  v-model="application.nameYonalish"
                  class="text-field"
                  solo
                  :required="true"
                  :rules="[$rules.required]"
                />
                <div class="position-relative">
                  <div
                    v-if="application.reviews.nameYonalish && !isReadonly"
                    v-text="application.reviews.nameYonalish"
                    class="red--text review-msg"
                  />
                </div>
              </template>
            </v-col>
            <template>
              <v-col cols="12" md="6">
                <div class="accent--text bold--text">
                  {{ $t("diplom copy") }}
                  <span v-text="'*'" />
                </div>
                <div
                  v-if="
                    application.reviews.foreignLanguageProficiencyPhoto &&
                    !isReadonly
                  "
                  v-text="application.reviews.foreignLanguageProficiencyPhoto"
                  class="red--text pb-2"
                />

                <upload-file
                  :readonly="isReadonly"
                  :required="true"
                  param="foreignLanguageProficiencyPhoto"
                />
              </v-col>
            </template>
          </v-row>

          <div class="d-flex pt-10">
            <v-spacer />
            <v-btn
              @click="$emit('prev')"
              color="error"
              dark
              elevation="0"
              class="border-0"
            >
              <v-icon left> mdi-arrow-left </v-icon>
              {{ $t("prev_btn") }}
            </v-btn>
            <div class="pl-1 pr-2"></div>
            <v-btn
              @click="onNext"
              color="accent"
              dark
              elevation="0"
              class="border-0"
            >
              {{ $t("next_btn") }}
              <v-icon right> mdi-arrow-right </v-icon>
            </v-btn>
          </div>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>
